import { render } from "./TransactionsTable.vue?vue&type=template&id=3bb4a75c&scoped=true"
import script from "./TransactionsTable.vue?vue&type=script&lang=js"
export * from "./TransactionsTable.vue?vue&type=script&lang=js"

import "./TransactionsTable.vue?vue&type=style&index=0&id=3bb4a75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb4a75c"]])

export default __exports__